import gql from 'graphql-tag'

export const GET_LATEST_SEARCHES = gql`
  query {
    latestSearches {
      buscas
    }
  }
`
